import {useMutation} from "react-query";
import axios from "services/axios";

export function useLogin(options = {}) {
	return useMutation(values => axios.post("/auth/login", values).then(res => res.data));
}

export function useLoginAs() {
	return useMutation(values => axios.get(`/patient/${values}/login_as`).then(res => res.data));
}

export function useGetTokenByCode() {
	return useMutation(values => axios.post("/sso/token", values).then(res => res.data));
}
